import type { ChatOrigin } from "@/stores/chat.store";

interface ResolveChatInputPlaceholderOptions {
  isStreaming: boolean;
  hasStarted: boolean;
  isMealPickerGreeting: boolean;
  chatOrigin: ChatOrigin | null;
}

export const resolveChatInputPlaceholder = ({
  isStreaming,
  hasStarted,
  isMealPickerGreeting,
  chatOrigin,
}: ResolveChatInputPlaceholderOptions) => {
  if (isStreaming) return "NutriCoach is working for you…";
  if (hasStarted) return "Start typing...";
  if (!isMealPickerGreeting) return "Something else...";

  // The dedicated meal-picker entry (Settings preview, origin
  // "meal-picker") nudges toward food; the general Coach greeting invites
  // any question. Keyed on origin, not route — the chat is a root-level
  // modal, so the underlying pathname is not reliable.
  return chatOrigin === "meal-picker"
    ? "Tell NutriCoach what you fancy..."
    : "Or ask me anything else…";
};
